export default __webpack_public_path__ + "images/34_1_image.jpg";